import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAssetDescriptionMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  description?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UpdateAssetDescriptionMutation = { updateAssets?: Maybe<Array<Maybe<{ __typename?: 'Asset', id: string }>>> };


export const UpdateAssetDescriptionDocument = gql`
    mutation updateAssetDescription($id: UUID!, $description: String) {
  updateAssets(assets: [{id: $id, description: $description}]) {
    id
  }
}
    `;
export type UpdateAssetDescriptionMutationFn = Apollo.MutationFunction<UpdateAssetDescriptionMutation, UpdateAssetDescriptionMutationVariables>;

/**
 * __useUpdateAssetDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateAssetDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetDescriptionMutation, { data, loading, error }] = useUpdateAssetDescriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateAssetDescriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAssetDescriptionMutation, UpdateAssetDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAssetDescriptionMutation, UpdateAssetDescriptionMutationVariables>(UpdateAssetDescriptionDocument, options);
      }
export type UpdateAssetDescriptionMutationHookResult = ReturnType<typeof useUpdateAssetDescriptionMutation>;
export type UpdateAssetDescriptionMutationResult = Apollo.MutationResult<UpdateAssetDescriptionMutation>;
export type UpdateAssetDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateAssetDescriptionMutation, UpdateAssetDescriptionMutationVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
